import * as React from 'react';
import * as Yup from 'yup';

import { useFormik } from 'formik';

import InputAdornment from '@mui/material/InputAdornment';
// icons
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
//import { useSnackbar } from 'notistack';
// utils
import axios from '../../utils/axios';
// hooks
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// 
import { useTranslation } from 'react-i18next';


const theme = createTheme();

export default function ChangePasswordForm() {
  const isMountedRef = useIsMountedRef();
  const { t } = useTranslation();
  const [alertError, setAlertError] = React.useState('');
  const [alertMessage, setAlertMessage] = React.useState('');

  const resetAlerts = () => {
    setAlertError('');
    setAlertMessage('');
  }

  const ChangePasswordSchema = Yup.object().shape({
    oldPassword: Yup.string().required(t("yup.errors.password_required")),
    password: Yup.string().required(t("yup.errors.password_required")),
    confirmPassword: Yup.string()
    .required('Conferma password obbligatoria.')
    .oneOf([Yup.ref('password'), null], 'Le password non corrispondono.'),
  });

  const formik = useFormik({
    initialValues: {
      oldPassword: '',
      password: '',
      confirmPassword: '',
    },
    validationSchema: ChangePasswordSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      try {
        resetAlerts();
        const response = await axios.post(`/auth/profile/update/password`, { old_password: values.oldPassword, password: values.password, password_confirmation: values.confirmPassword });

        if (response.data.success) {
          setAlertMessage(t(response.data.message));

          setInterval(() => {
            window.location.href = '/dashboard/profile';
          }, 1500);
        }
      } catch (error) {
        console.error(error);

        const errorMessage = Object.values(error.data)[0][0]
        setErrors({ afterSubmit: errorMessage });

        if (error.status === 422) {
          setAlertError(errorMessage);
          resetForm();
        } else {
          setAlertError(t(error.data.message));
        }

        if (isMountedRef.current) {
          resetForm({
            values: {
              oldPassword: '',
              password: '',
              confirmPassword: '',
            },
          });

          setSubmitting(false);
        }
      }
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (

    <Container component="div" sx={{ m: 0, p: 0, maxWidth: "unset !important" }}>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 0,
          m: 0,
        }}
      >

        <Typography component="h1" variant="h4" sx={{ color: '#004990', fontWeight: 'bold' }}>
          {t("profile.update.change_password_title")}
        </Typography>

        <form onSubmit={formik.handleSubmit}>
          {alertError && <Alert severity="error" sx={{ mt: 2, mb: 1 }}>{alertError}</Alert>}
          {alertMessage && <Alert severity="success" sx={{ mt: 2, mb: 1 }}>{alertMessage}</Alert>}

          <TextField
            margin="normal"
            variant="outlined"

            fullWidth
            id="oldPassword"
            name="oldPassword"
            label={t("authentication.fields.old_password")}
            autoComplete="oldPassword"
            autoFocus
            type="password"
            value={formik.values.oldPassword}
            onChange={formik.handleChange}
            error={formik.touched.oldPassword && Boolean(formik.errors.oldPassword)}
            helperText={formik.touched.oldPassword && formik.errors.oldPassword}
            sx={styles.inputText}

            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlinedIcon sx={{ color: "#6369E9" }} />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="normal"
            variant="outlined"

            fullWidth
            id="password"
            name="password"
            label={t("authentication.fields.new_password")}
            autoComplete="password"
            autoFocus
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            sx={styles.inputText}

            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlinedIcon sx={{ color: "#6369E9" }} />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="normal"
            variant="outlined"

            fullWidth
            id="confirmPassword"
            name="confirmPassword"
            label={t("authentication.fields.password_confirmation")}
            autoComplete="confirmPassword"
            autoFocus
            type="password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
            helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
            sx={styles.inputText}

            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlinedIcon sx={{ color: "#6369E9" }} />
                </InputAdornment>
              ),
            }}
          />

          <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 4, textAlign: "center" }}>
            <Button
              type="submit"
              variant="contained"
              sx={{
                width: '50%',
                p: '8px 50px',
                backgroundColor: '#2CA4DE'
              }}
            >
              {t("profile.update.change_password_submit")}
            </Button>
          </Stack>

        </form>
      </Box>

    </Container>
  );
}

const styles = {
  inputText: {
    // backgroundColor: '#EEF2F6',
    border: '0px solid',
    // p: '1rem',
    borderRadius: '10px',
  },
}